(ns kyber.shims
  (:require ["jss" :as jss]
            ["jss-preset-default" :as jss-preset]
            [goog.object :as gobj]))

;; For third party packages that use npm packages, we need to install them
;; separately, map the required package to its original npm package, and then
;; expose the expected global variable

(js/goog.exportSymbol "jss.default" (gobj/get jss "default"))
(js/goog.exportSymbol "jssPreset.default" (gobj/get jss-preset "default"))
